<template>
  <div class="image-upload">

    <!-- Upload -->
    <form
        enctype="multipart/form-data"
        novalidate
        v-if="isInitial || isSaving">

      <div class="dropbox">
        <b-form-file
            v-model="imageModel"
            :multiple="false"
            :placeholder="$t('form.choose_a_file_or_drop_it_here')"
            :drop-placeholder="$t('form.drop_file_here')"
            :name="uploadFieldName"
            accept="image/*"
            @change="filesChange($event.target.name, $event.target.files)"/>

        <div v-if="isSaving" class="position-relative">
          <loader class="mt-5"/>
        </div>

      </div>

    </form>

    <!-- Success -->
    <div v-if="isSuccess || hasPhoto">
      <div class="d-flex justify-content-between">
        <span>
          <b-button
              @click="reset"
              variant="outline-secondary"
              size="sm"
              class="py-0 ml-2">
            {{ $t('form.upload_new') }}
          </b-button>
        </span>
        <span>
          <b-button
              @click="remove"
              variant="outline-secondary"
              size="sm"
              class="py-0 ml-2">
            {{ $t('form.remove') }}
          </b-button>
        </span>
      </div>

      <div class="mt-3 d-flex justify-content-center" v-if="uploadedImage.url">
        <img :src="uploadedImage.url" class="img-fluid" :style="{height: imageHeight}" alt="logo"/>
      </div>

    </div>
  </div>
</template>

<script>
const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_HAS_IMAGE = 4;
import {get, isNull} from 'lodash';

export default {
  name: "ImageUploader",
  props: {
    image: {
      type: Object,
      default: () => ({
        url: null
      }),
    },
    imageHeight: {
      type: String,
      default: '280px'
    },
    responseImageUrlProperty: {
      type: String,
      default: 'logo'
    },
    uploadUrl: {
      type: String,
      default: 'resources/logo'
    }
  },
  data() {
    return {
      uploadedImage: null,
      currentStatus: null,
      uploadFieldName: 'file',
      imageModel: null
    }
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    hasPhoto() {
      return this.currentStatus === STATUS_HAS_IMAGE;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    }
  },
  methods: {
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedImage = null;
      this.imageModel = null
    },

    getCurrentImage() {
      if (isNull(this.image.url)) {
        return;
      }

      this.currentStatus = STATUS_HAS_IMAGE;
      this.uploadedImage = this.image;
      this.imageModel = this.image;
    },

    save(formData) {
      this.currentStatus = STATUS_SAVING;
      this.upload(formData)
          .then(data => {
            const imageUrl = get(data, `data.${this.responseImageUrlProperty}`, null);
            if (imageUrl) {
              this.uploadedImage = {url: imageUrl};
              this.currentStatus = STATUS_SUCCESS;
            } else {
              this.reset();
              this.$noty.error(this.$t('errors.something_went_wrong'));
            }

          })
          .catch(err => {
            this.reset();
            this.$noty.error(get(err, 'response.data.error_description', this.$t('errors.something_went_wrong')));
          });
    },

    filesChange(fieldName, fileList) {
      const formData = new FormData();
      if (!fileList.length) {
        return;
      }

      Array
          .from(Array(fileList.length).keys())
          .map(image => {
            formData.append(fieldName, fileList[image], fileList[image].name);
          });
      this.save(formData)
    },

    upload(formData) {
      return this.postData(`${this.uploadUrl}`, formData, null);
    },

    remove() {
      this.deleteData(`resources/logo`).then((data) => {
        const imageUrl = get(data, `data.${this.responseImageUrlProperty}`, null);
        if (imageUrl === null) {
          this.reset();
        }
      });
    },
  },

  async mounted() {
    if (!isNull(this.image.url)) {
      this.getCurrentImage()
    } else {
      this.reset();
    }
  },

  watch: {
    image() {
      this.getCurrentImage()
    }
  }
}
</script>
